
















import Vue from "vue";
import iwInputAutoComplete from "@/optimizedEncoding/components/buildingBlocks/InputAutoComplete.vue";
import { v4 as uuidv4 } from "uuid";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

// import mbxClient from "@mapbox/mapbox-sdk";
import mbxGeocoding, { GeocodeRequest } from "@mapbox/mapbox-sdk/services/geocoding";

// Interfaces
import { InputAutoCompleteSuggestions } from "@/shared/interfaces/InputAutoComplete.interface";
import { GeocodeFeature } from "@/shared/interfaces/mapbox/Geocoding.interface";

export default Vue.extend({
    components: {
        iwInputAutoComplete: iwInputAutoComplete
    },
    props: {
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        completeAddress: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function() {
        return {
            pathInStore: "customer.location.address.provided.street", // TO CHANGE WITH CORRECT PATH
            specificId: uuidv4() as string,
            suggestions: [] as Array<InputAutoCompleteSuggestions>,
            automaticPrefillAddress: true
        };
    },
    computed: {
        street: function(): string|null {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStore);
        },
    },
    mounted: function() {
        if (this.completeAddress && this.completeAddress.length > 0) {
            // Set the initial value in the store to pre-populate the input
            const street = this.completeAddress;
            this.$store.commit("FormModule/addValueUI", {path: this.pathInStore, value: street});
        }
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            this.$store.commit("FormModule/addValueUI", {path: this.pathInStore, value: value});
        },
        fetchSuggestions: function(value: string) {
            const mapBoxApiToken = process.env.VUE_APP_IMMOWEB_MAPBOX_API_TOKEN;

            if (mapBoxApiToken) {
                const geocodingClient = mbxGeocoding({
                    accessToken: mapBoxApiToken
                });

                if (value.length > 0) {
                    const optionsGeoCode: GeocodeRequest = {
                        mode: "mapbox.places",
                        query: value,
                        limit: 5,
                        proximity: [4.6644863, 50.6401734],
                        types: ["address", "poi"],
                        language: [Trans.currentLocale]
                    };

                    // IO-224: restrict suggestions to the selected billing country so the
                    // autocomplete can't be used to change the country (which the backend
                    // rejects after payment; see IO-222). Store holds uppercase ISO alpha-2.
                    const selectedCountry = this.$store.getters["FormModule/getValueUI"]("customer.location.address.provided.country");
                    if (selectedCountry) {
                        optionsGeoCode.countries = [selectedCountry.toLowerCase()];
                    }

                    geocodingClient.forwardGeocode(optionsGeoCode)
                        .send()
                        .then((response) => {

                            const predictions = response.body.features;

                            if (predictions) {
                                predictions.forEach((prediction: GeocodeFeature, index: number) => {

                                    let suggestionLabel = prediction.text;
                                    const placeContext = prediction.context as Array<GeocodeFeature>;

                                    let locality = "";
                                    let country = "";

                                    if (placeContext) {
                                        placeContext.forEach((entry) => {

                                            if (entry.id.indexOf("place") != -1) {
                                                locality = entry.text;
                                            }

                                            if (entry.id.indexOf("country") != -1) {
                                                country = entry.text;
                                            }
                                        });
                                    }

                                    if (prediction.address) {
                                        suggestionLabel += " " + prediction.address;
                                    }

                                    if (locality) {
                                        suggestionLabel += ", " + locality;
                                    }

                                    if (country) {
                                        suggestionLabel += ", " + country;
                                    }

                                    let inputFinalValue = prediction.text;


                                    const suggestion = {
                                        "label": suggestionLabel,
                                        "id": prediction.id,
                                        "originalObject": prediction,
                                        "inputFinalValue": inputFinalValue
                                    };

                                    if (this.suggestions.length < 5) {
                                        this.suggestions.push(suggestion);
                                    } else {
                                        Vue.set(this.suggestions, index, suggestion);
                                    }
                                });
                            }
                        });
                }
            }
        },
        autofillAddress: function (selectedValue: InputAutoCompleteSuggestions) {
            const originalObject = selectedValue.originalObject;

            if (originalObject) {

                const placeContext = originalObject.context;

                if(placeContext) {
                    placeContext.forEach((entry) => {

                        if (entry.id.indexOf("postcode") != -1) {

                            const postalCode = entry.text;

                            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.postalCode", value: postalCode});
                        }

                        if (entry.id.indexOf("place") != -1) {

                            const locality = entry.text;

                            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.locality", value: locality});
                        }

                        if (entry.id.indexOf("country") != -1) {
                            // IO-224: never let a picked suggestion change the country of a customer
                            // that has already paid (defensive; suggestions are already country-restricted).
                            const customerToEdit = this.$store.getters["FormModule/getValueUI"]("customer.customerToEdit");
                            if (customerToEdit?.hasPayment !== true) {
                                const country = entry.short_code.toUpperCase();

                                this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.country", value: country});
                            }
                        }
                    });
                }

                const number = originalObject.address;
                if (number) {
                    this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.streetNumber", value: number});
                }

                const placeType = originalObject.place_type as Array<string>;

                if (placeType) {
                    placeType.forEach((entry) => {
                        if (entry === "address" || entry === "poi") {
                            const street = originalObject.text;

                            this.$store.commit("FormModule/addValueUI", {path: "customer.location.address.provided.street", value: street});
                        }
                    });
                }

                this.$store.commit("FormModule/setErrors", null);
            }
        }
    }

});
